"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Stock Manager API
 * Collects and stores stock events emitted from kitchens
 *
 * The version of the OpenAPI document: 0.4.2
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StockTransferEventApi = exports.StockTransferEventApiFactory = exports.StockTransferEventApiFp = exports.StockTransferEventApiAxiosParamCreator = exports.StockOutEventApi = exports.StockOutEventApiFactory = exports.StockOutEventApiFp = exports.StockOutEventApiAxiosParamCreator = exports.StockInEventApi = exports.StockInEventApiFactory = exports.StockInEventApiFp = exports.StockInEventApiAxiosParamCreator = exports.StockEventApi = exports.StockEventApiFactory = exports.StockEventApiFp = exports.StockEventApiAxiosParamCreator = exports.LocationApi = exports.LocationApiFactory = exports.LocationApiFp = exports.LocationApiAxiosParamCreator = exports.TransferListOrderByParam = exports.StatusEnum = exports.ReasonEnum = exports.ObjectTypeEnum = exports.ListOrderByParam = exports.CurrencyEnum = exports.CompletionStatusEnum = void 0;
const axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
const common_1 = require("./common");
// @ts-ignore
const base_1 = require("./base");
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
var CompletionStatusEnum;
(function (CompletionStatusEnum) {
    CompletionStatusEnum["NotStarted"] = "NOT_STARTED";
    CompletionStatusEnum["InProgress"] = "IN_PROGRESS";
    CompletionStatusEnum["Completed"] = "COMPLETED";
    CompletionStatusEnum["Failed"] = "FAILED";
})(CompletionStatusEnum = exports.CompletionStatusEnum || (exports.CompletionStatusEnum = {}));
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
var CurrencyEnum;
(function (CurrencyEnum) {
    CurrencyEnum["Eur"] = "EUR";
    CurrencyEnum["Gbp"] = "GBP";
    CurrencyEnum["Uea"] = "UEA";
    CurrencyEnum["Usd"] = "USD";
})(CurrencyEnum = exports.CurrencyEnum || (exports.CurrencyEnum = {}));
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
var ListOrderByParam;
(function (ListOrderByParam) {
    ListOrderByParam["Date"] = "date";
    ListOrderByParam["TotalPrice"] = "total_price";
})(ListOrderByParam = exports.ListOrderByParam || (exports.ListOrderByParam = {}));
/**
 * Possible object type which can be bound to a stock event.
 * @export
 * @enum {string}
 */
var ObjectTypeEnum;
(function (ObjectTypeEnum) {
    ObjectTypeEnum["Product"] = "PRODUCT";
    ObjectTypeEnum["Item"] = "ITEM";
    ObjectTypeEnum["MenuItem"] = "MENU_ITEM";
})(ObjectTypeEnum = exports.ObjectTypeEnum || (exports.ObjectTypeEnum = {}));
/**
 * Possible reasons which can be associated to a Stock event.
 * @export
 * @enum {string}
 */
var ReasonEnum;
(function (ReasonEnum) {
    ReasonEnum["ShelfExpired"] = "SHELF_EXPIRED";
    ReasonEnum["DamagedProducts"] = "DAMAGED_PRODUCTS";
    ReasonEnum["EosWaste"] = "EOS_WASTE";
    ReasonEnum["ProcessStorageWaste"] = "PROCESS_STORAGE_WASTE";
    ReasonEnum["StaffFood"] = "STAFF_FOOD";
    ReasonEnum["RdMenus"] = "RD_MENUS";
    ReasonEnum["Training"] = "TRAINING";
    ReasonEnum["PhotoShooting"] = "PHOTO_SHOOTING";
    ReasonEnum["Marketing"] = "MARKETING";
    ReasonEnum["ProductOrderNotReceived"] = "PRODUCT_ORDER_NOT_RECEIVED";
    ReasonEnum["UnusualIncreaseOrders"] = "UNUSUAL_INCREASE_ORDERS";
    ReasonEnum["WrongOrderOos"] = "WRONG_ORDER_OOS";
    ReasonEnum["WrongOrderTooMuch"] = "WRONG_ORDER_TOO_MUCH";
})(ReasonEnum = exports.ReasonEnum || (exports.ReasonEnum = {}));
/**
 * Possible status of a transfer stock event.
 * @export
 * @enum {string}
 */
var StatusEnum;
(function (StatusEnum) {
    StatusEnum["AwaitingDelivery"] = "AWAITING_DELIVERY";
    StatusEnum["Delivered"] = "DELIVERED";
})(StatusEnum = exports.StatusEnum || (exports.StatusEnum = {}));
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
var TransferListOrderByParam;
(function (TransferListOrderByParam) {
    TransferListOrderByParam["Date"] = "date";
    TransferListOrderByParam["DeliveryDate"] = "delivery_date";
    TransferListOrderByParam["TotalPrice"] = "total_price";
})(TransferListOrderByParam = exports.TransferListOrderByParam || (exports.TransferListOrderByParam = {}));
/**
 * LocationApi - axios parameter creator
 * @export
 */
exports.LocationApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * **Scope**:      stock-object:read  **Parameters**:      location_uuid: the location to use to retrieve the menu item objects.
         * @summary Retrieves the list of Menu Item objects available in a given location.
         * @param {string} locationUuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listLocationMenuItems: (locationUuid, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'locationUuid' is not null or undefined
            common_1.assertParamExists('listLocationMenuItems', 'locationUuid', locationUuid);
            const localVarPath = `/location/{location_uuid}/menu-items`
                .replace(`{${"location_uuid"}}`, encodeURIComponent(String(locationUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication OAuth2 required
            // oauth required
            yield common_1.setOAuthToObject(localVarHeaderParameter, "OAuth2", ["stock-object:read"], configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * **Scope**:      stock-object:read  **Parameters**:      location_uuid: the location to use to retrieve the item objects.
         * @summary Retrieves the list of Item object available in a give location.
         * @param {string} locationUuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listLocationStockItems: (locationUuid, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'locationUuid' is not null or undefined
            common_1.assertParamExists('listLocationStockItems', 'locationUuid', locationUuid);
            const localVarPath = `/location/{location_uuid}/items`
                .replace(`{${"location_uuid"}}`, encodeURIComponent(String(locationUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication OAuth2 required
            // oauth required
            yield common_1.setOAuthToObject(localVarHeaderParameter, "OAuth2", ["stock-object:read"], configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * **Scope**:      stock-object:read  **Parameters**:      location_uuid: the location to use to retrieve the stock objects.
         * @summary Retrieves the list of Stock objects (eg. items, menu items and products) available in a given location.
         * @param {string} locationUuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listLocationStockObjects: (locationUuid, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'locationUuid' is not null or undefined
            common_1.assertParamExists('listLocationStockObjects', 'locationUuid', locationUuid);
            const localVarPath = `/location/{location_uuid}/objects`
                .replace(`{${"location_uuid"}}`, encodeURIComponent(String(locationUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication OAuth2 required
            // oauth required
            yield common_1.setOAuthToObject(localVarHeaderParameter, "OAuth2", ["stock-object:read"], configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * **Scope**:      stock-object:read  **Parameters**:      location_uuid: the location to use to retrieve the product objects.
         * @summary Retrieve the list of Product objects available in a given location.
         * @param {string} locationUuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listLocationStockProducts: (locationUuid, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'locationUuid' is not null or undefined
            common_1.assertParamExists('listLocationStockProducts', 'locationUuid', locationUuid);
            const localVarPath = `/location/{location_uuid}/products`
                .replace(`{${"location_uuid"}}`, encodeURIComponent(String(locationUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication OAuth2 required
            // oauth required
            yield common_1.setOAuthToObject(localVarHeaderParameter, "OAuth2", ["stock-object:read"], configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * LocationApi - functional programming interface
 * @export
 */
exports.LocationApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.LocationApiAxiosParamCreator(configuration);
    return {
        /**
         * **Scope**:      stock-object:read  **Parameters**:      location_uuid: the location to use to retrieve the menu item objects.
         * @summary Retrieves the list of Menu Item objects available in a given location.
         * @param {string} locationUuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listLocationMenuItems(locationUuid, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listLocationMenuItems(locationUuid, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * **Scope**:      stock-object:read  **Parameters**:      location_uuid: the location to use to retrieve the item objects.
         * @summary Retrieves the list of Item object available in a give location.
         * @param {string} locationUuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listLocationStockItems(locationUuid, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listLocationStockItems(locationUuid, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * **Scope**:      stock-object:read  **Parameters**:      location_uuid: the location to use to retrieve the stock objects.
         * @summary Retrieves the list of Stock objects (eg. items, menu items and products) available in a given location.
         * @param {string} locationUuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listLocationStockObjects(locationUuid, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listLocationStockObjects(locationUuid, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * **Scope**:      stock-object:read  **Parameters**:      location_uuid: the location to use to retrieve the product objects.
         * @summary Retrieve the list of Product objects available in a given location.
         * @param {string} locationUuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listLocationStockProducts(locationUuid, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listLocationStockProducts(locationUuid, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
/**
 * LocationApi - factory interface
 * @export
 */
exports.LocationApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.LocationApiFp(configuration);
    return {
        /**
         * **Scope**:      stock-object:read  **Parameters**:      location_uuid: the location to use to retrieve the menu item objects.
         * @summary Retrieves the list of Menu Item objects available in a given location.
         * @param {string} locationUuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listLocationMenuItems(locationUuid, options) {
            return localVarFp.listLocationMenuItems(locationUuid, options).then((request) => request(axios, basePath));
        },
        /**
         * **Scope**:      stock-object:read  **Parameters**:      location_uuid: the location to use to retrieve the item objects.
         * @summary Retrieves the list of Item object available in a give location.
         * @param {string} locationUuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listLocationStockItems(locationUuid, options) {
            return localVarFp.listLocationStockItems(locationUuid, options).then((request) => request(axios, basePath));
        },
        /**
         * **Scope**:      stock-object:read  **Parameters**:      location_uuid: the location to use to retrieve the stock objects.
         * @summary Retrieves the list of Stock objects (eg. items, menu items and products) available in a given location.
         * @param {string} locationUuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listLocationStockObjects(locationUuid, options) {
            return localVarFp.listLocationStockObjects(locationUuid, options).then((request) => request(axios, basePath));
        },
        /**
         * **Scope**:      stock-object:read  **Parameters**:      location_uuid: the location to use to retrieve the product objects.
         * @summary Retrieve the list of Product objects available in a given location.
         * @param {string} locationUuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listLocationStockProducts(locationUuid, options) {
            return localVarFp.listLocationStockProducts(locationUuid, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * LocationApi - object-oriented interface
 * @export
 * @class LocationApi
 * @extends {BaseAPI}
 */
class LocationApi extends base_1.BaseAPI {
    /**
     * **Scope**:      stock-object:read  **Parameters**:      location_uuid: the location to use to retrieve the menu item objects.
     * @summary Retrieves the list of Menu Item objects available in a given location.
     * @param {string} locationUuid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationApi
     */
    listLocationMenuItems(locationUuid, options) {
        return exports.LocationApiFp(this.configuration).listLocationMenuItems(locationUuid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * **Scope**:      stock-object:read  **Parameters**:      location_uuid: the location to use to retrieve the item objects.
     * @summary Retrieves the list of Item object available in a give location.
     * @param {string} locationUuid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationApi
     */
    listLocationStockItems(locationUuid, options) {
        return exports.LocationApiFp(this.configuration).listLocationStockItems(locationUuid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * **Scope**:      stock-object:read  **Parameters**:      location_uuid: the location to use to retrieve the stock objects.
     * @summary Retrieves the list of Stock objects (eg. items, menu items and products) available in a given location.
     * @param {string} locationUuid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationApi
     */
    listLocationStockObjects(locationUuid, options) {
        return exports.LocationApiFp(this.configuration).listLocationStockObjects(locationUuid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * **Scope**:      stock-object:read  **Parameters**:      location_uuid: the location to use to retrieve the product objects.
     * @summary Retrieve the list of Product objects available in a given location.
     * @param {string} locationUuid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationApi
     */
    listLocationStockProducts(locationUuid, options) {
        return exports.LocationApiFp(this.configuration).listLocationStockProducts(locationUuid, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.LocationApi = LocationApi;
/**
 * StockEventApi - axios parameter creator
 * @export
 */
exports.StockEventApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * **Scope**:      stock-out:read   **Parameters**:      reason: A reason to only select events which have this reason specified.     location_uuid: An UUID to use to only select events emitted by a specific Kitchen.     order_by: A field to uses when ordering the collection.     desc: Should the ordering be reversed?     with_deleted: Should we retrieve soft-deleted events too?
         * @summary Retrieve all Stock events
         * @param {ReasonEnum} [reason]
         * @param {string} [locationUuid]
         * @param {ListOrderByParam} [orderBy]
         * @param {boolean} [desc]
         * @param {boolean} [withDeleted]
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        listEvent: (reason, locationUuid, orderBy, desc, withDeleted, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/event`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication OAuth2 required
            // oauth required
            yield common_1.setOAuthToObject(localVarHeaderParameter, "OAuth2", ["stock-out:read"], configuration);
            if (reason !== undefined) {
                localVarQueryParameter['reason'] = reason;
            }
            if (locationUuid !== undefined) {
                localVarQueryParameter['location_uuid'] = locationUuid;
            }
            if (orderBy !== undefined) {
                localVarQueryParameter['order_by'] = orderBy;
            }
            if (desc !== undefined) {
                localVarQueryParameter['desc'] = desc;
            }
            if (withDeleted !== undefined) {
                localVarQueryParameter['with_deleted'] = withDeleted;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * StockEventApi - functional programming interface
 * @export
 */
exports.StockEventApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.StockEventApiAxiosParamCreator(configuration);
    return {
        /**
         * **Scope**:      stock-out:read   **Parameters**:      reason: A reason to only select events which have this reason specified.     location_uuid: An UUID to use to only select events emitted by a specific Kitchen.     order_by: A field to uses when ordering the collection.     desc: Should the ordering be reversed?     with_deleted: Should we retrieve soft-deleted events too?
         * @summary Retrieve all Stock events
         * @param {ReasonEnum} [reason]
         * @param {string} [locationUuid]
         * @param {ListOrderByParam} [orderBy]
         * @param {boolean} [desc]
         * @param {boolean} [withDeleted]
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        listEvent(reason, locationUuid, orderBy, desc, withDeleted, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listEvent(reason, locationUuid, orderBy, desc, withDeleted, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
/**
 * StockEventApi - factory interface
 * @export
 */
exports.StockEventApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.StockEventApiFp(configuration);
    return {
        /**
         * **Scope**:      stock-out:read   **Parameters**:      reason: A reason to only select events which have this reason specified.     location_uuid: An UUID to use to only select events emitted by a specific Kitchen.     order_by: A field to uses when ordering the collection.     desc: Should the ordering be reversed?     with_deleted: Should we retrieve soft-deleted events too?
         * @summary Retrieve all Stock events
         * @param {ReasonEnum} [reason]
         * @param {string} [locationUuid]
         * @param {ListOrderByParam} [orderBy]
         * @param {boolean} [desc]
         * @param {boolean} [withDeleted]
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        listEvent(reason, locationUuid, orderBy, desc, withDeleted, options) {
            return localVarFp.listEvent(reason, locationUuid, orderBy, desc, withDeleted, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * StockEventApi - object-oriented interface
 * @export
 * @class StockEventApi
 * @extends {BaseAPI}
 */
class StockEventApi extends base_1.BaseAPI {
    /**
     * **Scope**:      stock-out:read   **Parameters**:      reason: A reason to only select events which have this reason specified.     location_uuid: An UUID to use to only select events emitted by a specific Kitchen.     order_by: A field to uses when ordering the collection.     desc: Should the ordering be reversed?     with_deleted: Should we retrieve soft-deleted events too?
     * @summary Retrieve all Stock events
     * @param {ReasonEnum} [reason]
     * @param {string} [locationUuid]
     * @param {ListOrderByParam} [orderBy]
     * @param {boolean} [desc]
     * @param {boolean} [withDeleted]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof StockEventApi
     */
    listEvent(reason, locationUuid, orderBy, desc, withDeleted, options) {
        return exports.StockEventApiFp(this.configuration).listEvent(reason, locationUuid, orderBy, desc, withDeleted, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.StockEventApi = StockEventApi;
/**
 * StockInEventApi - axios parameter creator
 * @export
 */
exports.StockInEventApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * **Scope**:      stock-in:write
         * @summary Create a new Stock In event.
         * @param {StockInRequest} stockInRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createStockIn: (stockInRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'stockInRequest' is not null or undefined
            common_1.assertParamExists('createStockIn', 'stockInRequest', stockInRequest);
            const localVarPath = `/stock-in`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication OAuth2 required
            // oauth required
            yield common_1.setOAuthToObject(localVarHeaderParameter, "OAuth2", ["stock-in:write"], configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(stockInRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * **Scope**:      stock-in:admin  **Parameters**:      uuid: The Stock In event\'s UUID to delete.
         * @summary Delete a Stock In event for a given UUID.
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteStockIn: (uuid, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            common_1.assertParamExists('deleteStockIn', 'uuid', uuid);
            const localVarPath = `/stock-in/{uuid}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication OAuth2 required
            // oauth required
            yield common_1.setOAuthToObject(localVarHeaderParameter, "OAuth2", ["stock-in:admin"], configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * **Scopes**:      stock-in:read  **Parameters**:      uuid: The Stock In event\'s UUID to retrieve.
         * @summary Get a Stock In event for a given UUID.
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStockIn: (uuid, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            common_1.assertParamExists('getStockIn', 'uuid', uuid);
            const localVarPath = `/stock-in/{uuid}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication OAuth2 required
            // oauth required
            yield common_1.setOAuthToObject(localVarHeaderParameter, "OAuth2", ["stock-in:read"], configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * **Scopes*:      stock-in:read  **Parameters**:      uuid: The Stock In event\'s UUID.     expiration: A custom duration, in minutes, for the expiration delay of the signed URL.
         * @summary Get the signed URL to a Stock In event\'s receipt for a given UUID.
         * @param {string} uuid
         * @param {number} [expiration]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStockInReceipt: (uuid, expiration, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            common_1.assertParamExists('getStockInReceipt', 'uuid', uuid);
            const localVarPath = `/stock-in/{uuid}/receipt`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication OAuth2 required
            // oauth required
            yield common_1.setOAuthToObject(localVarHeaderParameter, "OAuth2", ["stock-in:read"], configuration);
            if (expiration !== undefined) {
                localVarQueryParameter['expiration'] = expiration;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * **Scope**:      stock-in:read  **Parameters**:      reason: A reason to only select events which have this reason specified.     location_uuid: An UUID to use to only select events emitted by a specific Kitchen.     order_by: A field to uses when ordering the collection.     desc: Should the ordering be reversed?     start_after: An event UUID to use to start the iterator page after.     per_page: The number of event per page (by default it\'s 20).     with_deleted: Should we retrieve soft-deleted events too?
         * @summary Retrieve all StockIn events.
         * @param {ReasonEnum} [reason]
         * @param {string} [locationUuid]
         * @param {ListOrderByParam} [orderBy]
         * @param {boolean} [desc]
         * @param {string} [startAfter]
         * @param {number} [perPage]
         * @param {boolean} [withDeleted]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listStockIn: (reason, locationUuid, orderBy, desc, startAfter, perPage, withDeleted, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/stock-in`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication OAuth2 required
            // oauth required
            yield common_1.setOAuthToObject(localVarHeaderParameter, "OAuth2", ["stock-in:read"], configuration);
            if (reason !== undefined) {
                localVarQueryParameter['reason'] = reason;
            }
            if (locationUuid !== undefined) {
                localVarQueryParameter['location_uuid'] = locationUuid;
            }
            if (orderBy !== undefined) {
                localVarQueryParameter['order_by'] = orderBy;
            }
            if (desc !== undefined) {
                localVarQueryParameter['desc'] = desc;
            }
            if (startAfter !== undefined) {
                localVarQueryParameter['start_after'] = startAfter;
            }
            if (perPage !== undefined) {
                localVarQueryParameter['per_page'] = perPage;
            }
            if (withDeleted !== undefined) {
                localVarQueryParameter['with_deleted'] = withDeleted;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * **Scope**:      stock-in:write  **Parameters**:      uuid: the Stock In event\'s UUID to update.
         * @summary Updates the product list of a Stock In event with a given UUID.
         * @param {string} uuid
         * @param {StockInProductsUpdateRequest} stockInProductsUpdateRequest
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        oldUpdateStockInProducts: (uuid, stockInProductsUpdateRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            common_1.assertParamExists('oldUpdateStockInProducts', 'uuid', uuid);
            // verify required parameter 'stockInProductsUpdateRequest' is not null or undefined
            common_1.assertParamExists('oldUpdateStockInProducts', 'stockInProductsUpdateRequest', stockInProductsUpdateRequest);
            const localVarPath = `/stock-in/{uuid}/products`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication OAuth2 required
            // oauth required
            yield common_1.setOAuthToObject(localVarHeaderParameter, "OAuth2", ["stock-in:write"], configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(stockInProductsUpdateRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * **Scope**:      stock-in:write  **Parameters**:      uuid: The Stock In event\'s UUID to update.
         * @summary Update a Stock In event for a given UUID.
         * @param {string} uuid
         * @param {StockInUpdateRequest} stockInUpdateRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateStockIn: (uuid, stockInUpdateRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            common_1.assertParamExists('updateStockIn', 'uuid', uuid);
            // verify required parameter 'stockInUpdateRequest' is not null or undefined
            common_1.assertParamExists('updateStockIn', 'stockInUpdateRequest', stockInUpdateRequest);
            const localVarPath = `/stock-in/{uuid}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication OAuth2 required
            // oauth required
            yield common_1.setOAuthToObject(localVarHeaderParameter, "OAuth2", ["stock-in:write"], configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(stockInUpdateRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * **Scope**:      stock-in:write  **Parameters**:      uuid: the Stock In event\'s UUID to update.
         * @summary Updates the product list of a Stock In event with a given UUID.
         * @param {string} uuid
         * @param {StockInProductsUpdateRequest} stockInProductsUpdateRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateStockInProducts: (uuid, stockInProductsUpdateRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            common_1.assertParamExists('updateStockInProducts', 'uuid', uuid);
            // verify required parameter 'stockInProductsUpdateRequest' is not null or undefined
            common_1.assertParamExists('updateStockInProducts', 'stockInProductsUpdateRequest', stockInProductsUpdateRequest);
            const localVarPath = `/stock-in/{uuid}/products`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication OAuth2 required
            // oauth required
            yield common_1.setOAuthToObject(localVarHeaderParameter, "OAuth2", ["stock-in:write"], configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(stockInProductsUpdateRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * **Scope**:      stock-in:write  **Parameters**:      uuid: The Stock In event\'s UUID to attach to the note.
         * @summary Upload a grocery note to attach to a Stock In even for a given UUID.
         * @param {string} uuid
         * @param {any} note
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadStockInNote: (uuid, note, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            common_1.assertParamExists('uploadStockInNote', 'uuid', uuid);
            // verify required parameter 'note' is not null or undefined
            common_1.assertParamExists('uploadStockInNote', 'note', note);
            const localVarPath = `/stock-in/{uuid}/upload-note`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();
            // authentication OAuth2 required
            // oauth required
            yield common_1.setOAuthToObject(localVarHeaderParameter, "OAuth2", ["stock-in:write"], configuration);
            if (note !== undefined) {
                localVarFormParams.append('note', note);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = localVarFormParams;
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * StockInEventApi - functional programming interface
 * @export
 */
exports.StockInEventApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.StockInEventApiAxiosParamCreator(configuration);
    return {
        /**
         * **Scope**:      stock-in:write
         * @summary Create a new Stock In event.
         * @param {StockInRequest} stockInRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createStockIn(stockInRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createStockIn(stockInRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * **Scope**:      stock-in:admin  **Parameters**:      uuid: The Stock In event\'s UUID to delete.
         * @summary Delete a Stock In event for a given UUID.
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteStockIn(uuid, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteStockIn(uuid, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * **Scopes**:      stock-in:read  **Parameters**:      uuid: The Stock In event\'s UUID to retrieve.
         * @summary Get a Stock In event for a given UUID.
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStockIn(uuid, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getStockIn(uuid, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * **Scopes*:      stock-in:read  **Parameters**:      uuid: The Stock In event\'s UUID.     expiration: A custom duration, in minutes, for the expiration delay of the signed URL.
         * @summary Get the signed URL to a Stock In event\'s receipt for a given UUID.
         * @param {string} uuid
         * @param {number} [expiration]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStockInReceipt(uuid, expiration, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getStockInReceipt(uuid, expiration, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * **Scope**:      stock-in:read  **Parameters**:      reason: A reason to only select events which have this reason specified.     location_uuid: An UUID to use to only select events emitted by a specific Kitchen.     order_by: A field to uses when ordering the collection.     desc: Should the ordering be reversed?     start_after: An event UUID to use to start the iterator page after.     per_page: The number of event per page (by default it\'s 20).     with_deleted: Should we retrieve soft-deleted events too?
         * @summary Retrieve all StockIn events.
         * @param {ReasonEnum} [reason]
         * @param {string} [locationUuid]
         * @param {ListOrderByParam} [orderBy]
         * @param {boolean} [desc]
         * @param {string} [startAfter]
         * @param {number} [perPage]
         * @param {boolean} [withDeleted]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listStockIn(reason, locationUuid, orderBy, desc, startAfter, perPage, withDeleted, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listStockIn(reason, locationUuid, orderBy, desc, startAfter, perPage, withDeleted, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * **Scope**:      stock-in:write  **Parameters**:      uuid: the Stock In event\'s UUID to update.
         * @summary Updates the product list of a Stock In event with a given UUID.
         * @param {string} uuid
         * @param {StockInProductsUpdateRequest} stockInProductsUpdateRequest
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        oldUpdateStockInProducts(uuid, stockInProductsUpdateRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.oldUpdateStockInProducts(uuid, stockInProductsUpdateRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * **Scope**:      stock-in:write  **Parameters**:      uuid: The Stock In event\'s UUID to update.
         * @summary Update a Stock In event for a given UUID.
         * @param {string} uuid
         * @param {StockInUpdateRequest} stockInUpdateRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateStockIn(uuid, stockInUpdateRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateStockIn(uuid, stockInUpdateRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * **Scope**:      stock-in:write  **Parameters**:      uuid: the Stock In event\'s UUID to update.
         * @summary Updates the product list of a Stock In event with a given UUID.
         * @param {string} uuid
         * @param {StockInProductsUpdateRequest} stockInProductsUpdateRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateStockInProducts(uuid, stockInProductsUpdateRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateStockInProducts(uuid, stockInProductsUpdateRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * **Scope**:      stock-in:write  **Parameters**:      uuid: The Stock In event\'s UUID to attach to the note.
         * @summary Upload a grocery note to attach to a Stock In even for a given UUID.
         * @param {string} uuid
         * @param {any} note
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadStockInNote(uuid, note, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.uploadStockInNote(uuid, note, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
/**
 * StockInEventApi - factory interface
 * @export
 */
exports.StockInEventApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.StockInEventApiFp(configuration);
    return {
        /**
         * **Scope**:      stock-in:write
         * @summary Create a new Stock In event.
         * @param {StockInRequest} stockInRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createStockIn(stockInRequest, options) {
            return localVarFp.createStockIn(stockInRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * **Scope**:      stock-in:admin  **Parameters**:      uuid: The Stock In event\'s UUID to delete.
         * @summary Delete a Stock In event for a given UUID.
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteStockIn(uuid, options) {
            return localVarFp.deleteStockIn(uuid, options).then((request) => request(axios, basePath));
        },
        /**
         * **Scopes**:      stock-in:read  **Parameters**:      uuid: The Stock In event\'s UUID to retrieve.
         * @summary Get a Stock In event for a given UUID.
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStockIn(uuid, options) {
            return localVarFp.getStockIn(uuid, options).then((request) => request(axios, basePath));
        },
        /**
         * **Scopes*:      stock-in:read  **Parameters**:      uuid: The Stock In event\'s UUID.     expiration: A custom duration, in minutes, for the expiration delay of the signed URL.
         * @summary Get the signed URL to a Stock In event\'s receipt for a given UUID.
         * @param {string} uuid
         * @param {number} [expiration]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStockInReceipt(uuid, expiration, options) {
            return localVarFp.getStockInReceipt(uuid, expiration, options).then((request) => request(axios, basePath));
        },
        /**
         * **Scope**:      stock-in:read  **Parameters**:      reason: A reason to only select events which have this reason specified.     location_uuid: An UUID to use to only select events emitted by a specific Kitchen.     order_by: A field to uses when ordering the collection.     desc: Should the ordering be reversed?     start_after: An event UUID to use to start the iterator page after.     per_page: The number of event per page (by default it\'s 20).     with_deleted: Should we retrieve soft-deleted events too?
         * @summary Retrieve all StockIn events.
         * @param {ReasonEnum} [reason]
         * @param {string} [locationUuid]
         * @param {ListOrderByParam} [orderBy]
         * @param {boolean} [desc]
         * @param {string} [startAfter]
         * @param {number} [perPage]
         * @param {boolean} [withDeleted]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listStockIn(reason, locationUuid, orderBy, desc, startAfter, perPage, withDeleted, options) {
            return localVarFp.listStockIn(reason, locationUuid, orderBy, desc, startAfter, perPage, withDeleted, options).then((request) => request(axios, basePath));
        },
        /**
         * **Scope**:      stock-in:write  **Parameters**:      uuid: the Stock In event\'s UUID to update.
         * @summary Updates the product list of a Stock In event with a given UUID.
         * @param {string} uuid
         * @param {StockInProductsUpdateRequest} stockInProductsUpdateRequest
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        oldUpdateStockInProducts(uuid, stockInProductsUpdateRequest, options) {
            return localVarFp.oldUpdateStockInProducts(uuid, stockInProductsUpdateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * **Scope**:      stock-in:write  **Parameters**:      uuid: The Stock In event\'s UUID to update.
         * @summary Update a Stock In event for a given UUID.
         * @param {string} uuid
         * @param {StockInUpdateRequest} stockInUpdateRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateStockIn(uuid, stockInUpdateRequest, options) {
            return localVarFp.updateStockIn(uuid, stockInUpdateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * **Scope**:      stock-in:write  **Parameters**:      uuid: the Stock In event\'s UUID to update.
         * @summary Updates the product list of a Stock In event with a given UUID.
         * @param {string} uuid
         * @param {StockInProductsUpdateRequest} stockInProductsUpdateRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateStockInProducts(uuid, stockInProductsUpdateRequest, options) {
            return localVarFp.updateStockInProducts(uuid, stockInProductsUpdateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * **Scope**:      stock-in:write  **Parameters**:      uuid: The Stock In event\'s UUID to attach to the note.
         * @summary Upload a grocery note to attach to a Stock In even for a given UUID.
         * @param {string} uuid
         * @param {any} note
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadStockInNote(uuid, note, options) {
            return localVarFp.uploadStockInNote(uuid, note, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * StockInEventApi - object-oriented interface
 * @export
 * @class StockInEventApi
 * @extends {BaseAPI}
 */
class StockInEventApi extends base_1.BaseAPI {
    /**
     * **Scope**:      stock-in:write
     * @summary Create a new Stock In event.
     * @param {StockInRequest} stockInRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StockInEventApi
     */
    createStockIn(stockInRequest, options) {
        return exports.StockInEventApiFp(this.configuration).createStockIn(stockInRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * **Scope**:      stock-in:admin  **Parameters**:      uuid: The Stock In event\'s UUID to delete.
     * @summary Delete a Stock In event for a given UUID.
     * @param {string} uuid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StockInEventApi
     */
    deleteStockIn(uuid, options) {
        return exports.StockInEventApiFp(this.configuration).deleteStockIn(uuid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * **Scopes**:      stock-in:read  **Parameters**:      uuid: The Stock In event\'s UUID to retrieve.
     * @summary Get a Stock In event for a given UUID.
     * @param {string} uuid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StockInEventApi
     */
    getStockIn(uuid, options) {
        return exports.StockInEventApiFp(this.configuration).getStockIn(uuid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * **Scopes*:      stock-in:read  **Parameters**:      uuid: The Stock In event\'s UUID.     expiration: A custom duration, in minutes, for the expiration delay of the signed URL.
     * @summary Get the signed URL to a Stock In event\'s receipt for a given UUID.
     * @param {string} uuid
     * @param {number} [expiration]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StockInEventApi
     */
    getStockInReceipt(uuid, expiration, options) {
        return exports.StockInEventApiFp(this.configuration).getStockInReceipt(uuid, expiration, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * **Scope**:      stock-in:read  **Parameters**:      reason: A reason to only select events which have this reason specified.     location_uuid: An UUID to use to only select events emitted by a specific Kitchen.     order_by: A field to uses when ordering the collection.     desc: Should the ordering be reversed?     start_after: An event UUID to use to start the iterator page after.     per_page: The number of event per page (by default it\'s 20).     with_deleted: Should we retrieve soft-deleted events too?
     * @summary Retrieve all StockIn events.
     * @param {ReasonEnum} [reason]
     * @param {string} [locationUuid]
     * @param {ListOrderByParam} [orderBy]
     * @param {boolean} [desc]
     * @param {string} [startAfter]
     * @param {number} [perPage]
     * @param {boolean} [withDeleted]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StockInEventApi
     */
    listStockIn(reason, locationUuid, orderBy, desc, startAfter, perPage, withDeleted, options) {
        return exports.StockInEventApiFp(this.configuration).listStockIn(reason, locationUuid, orderBy, desc, startAfter, perPage, withDeleted, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * **Scope**:      stock-in:write  **Parameters**:      uuid: the Stock In event\'s UUID to update.
     * @summary Updates the product list of a Stock In event with a given UUID.
     * @param {string} uuid
     * @param {StockInProductsUpdateRequest} stockInProductsUpdateRequest
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof StockInEventApi
     */
    oldUpdateStockInProducts(uuid, stockInProductsUpdateRequest, options) {
        return exports.StockInEventApiFp(this.configuration).oldUpdateStockInProducts(uuid, stockInProductsUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * **Scope**:      stock-in:write  **Parameters**:      uuid: The Stock In event\'s UUID to update.
     * @summary Update a Stock In event for a given UUID.
     * @param {string} uuid
     * @param {StockInUpdateRequest} stockInUpdateRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StockInEventApi
     */
    updateStockIn(uuid, stockInUpdateRequest, options) {
        return exports.StockInEventApiFp(this.configuration).updateStockIn(uuid, stockInUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * **Scope**:      stock-in:write  **Parameters**:      uuid: the Stock In event\'s UUID to update.
     * @summary Updates the product list of a Stock In event with a given UUID.
     * @param {string} uuid
     * @param {StockInProductsUpdateRequest} stockInProductsUpdateRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StockInEventApi
     */
    updateStockInProducts(uuid, stockInProductsUpdateRequest, options) {
        return exports.StockInEventApiFp(this.configuration).updateStockInProducts(uuid, stockInProductsUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * **Scope**:      stock-in:write  **Parameters**:      uuid: The Stock In event\'s UUID to attach to the note.
     * @summary Upload a grocery note to attach to a Stock In even for a given UUID.
     * @param {string} uuid
     * @param {any} note
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StockInEventApi
     */
    uploadStockInNote(uuid, note, options) {
        return exports.StockInEventApiFp(this.configuration).uploadStockInNote(uuid, note, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.StockInEventApi = StockInEventApi;
/**
 * StockOutEventApi - axios parameter creator
 * @export
 */
exports.StockOutEventApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * **Scope**:      stock-out:write
         * @summary Create a new Stock Out event
         * @param {StockOutRequest} stockOutRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createStockOut: (stockOutRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'stockOutRequest' is not null or undefined
            common_1.assertParamExists('createStockOut', 'stockOutRequest', stockOutRequest);
            const localVarPath = `/stock-out`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication OAuth2 required
            // oauth required
            yield common_1.setOAuthToObject(localVarHeaderParameter, "OAuth2", ["stock-out:write"], configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(stockOutRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * **Scope**:      stock_outs:admin  **Parameters**:      uuid: The Stock Out event\'s UUID to delete
         * @summary Delete StockOut for a given UUID
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteStockOut: (uuid, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            common_1.assertParamExists('deleteStockOut', 'uuid', uuid);
            const localVarPath = `/stock-out/{uuid}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication OAuth2 required
            // oauth required
            yield common_1.setOAuthToObject(localVarHeaderParameter, "OAuth2", ["stock-out:admin"], configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * **Scope**:      stock-out:read  **Parameters**:      stock_out_uuid: The Stock Out event\'s UUID to retrieve.
         * @summary Get Stock Out for a given UUID
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStockOut: (uuid, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            common_1.assertParamExists('getStockOut', 'uuid', uuid);
            const localVarPath = `/stock-out/{uuid}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication OAuth2 required
            // oauth required
            yield common_1.setOAuthToObject(localVarHeaderParameter, "OAuth2", ["stock-out:read"], configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * **Scope**:      stock-out:read  **Parameters**:      reason: A reason to only select events which have this reason specified.     location_uuid: An UUID to use to only select events emitted by a specific Kitchen.     order_by: A field to uses when ordering the collection.     desc: Should the ordering be reversed?     start_after: An event UUID to use to start the iterator page after.     per_page: The number of event per page (by default it\'s 20).     with_deleted: Should we retrieve soft-deleted events too?
         * @summary Retrieve all StockOut
         * @param {ReasonEnum} [reason]
         * @param {string} [locationUuid]
         * @param {ListOrderByParam} [orderBy]
         * @param {boolean} [desc]
         * @param {string} [startAfter]
         * @param {number} [perPage]
         * @param {boolean} [withDeleted]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listStockOut: (reason, locationUuid, orderBy, desc, startAfter, perPage, withDeleted, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/stock-out`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication OAuth2 required
            // oauth required
            yield common_1.setOAuthToObject(localVarHeaderParameter, "OAuth2", ["stock-out:read"], configuration);
            if (reason !== undefined) {
                localVarQueryParameter['reason'] = reason;
            }
            if (locationUuid !== undefined) {
                localVarQueryParameter['location_uuid'] = locationUuid;
            }
            if (orderBy !== undefined) {
                localVarQueryParameter['order_by'] = orderBy;
            }
            if (desc !== undefined) {
                localVarQueryParameter['desc'] = desc;
            }
            if (startAfter !== undefined) {
                localVarQueryParameter['start_after'] = startAfter;
            }
            if (perPage !== undefined) {
                localVarQueryParameter['per_page'] = perPage;
            }
            if (withDeleted !== undefined) {
                localVarQueryParameter['with_deleted'] = withDeleted;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * **Scope**:      stock-out:write  **Parameters**:      uuid: The Stock Out event\'s UUID to update.
         * @summary Updates the product list of a Stock Out event with the given UUID
         * @param {string} uuid
         * @param {StockOutProductsUpdateRequest} stockOutProductsUpdateRequest
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        oldUpdateStockOutProducts: (uuid, stockOutProductsUpdateRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            common_1.assertParamExists('oldUpdateStockOutProducts', 'uuid', uuid);
            // verify required parameter 'stockOutProductsUpdateRequest' is not null or undefined
            common_1.assertParamExists('oldUpdateStockOutProducts', 'stockOutProductsUpdateRequest', stockOutProductsUpdateRequest);
            const localVarPath = `/stock-out/{uuid}/products`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication OAuth2 required
            // oauth required
            yield common_1.setOAuthToObject(localVarHeaderParameter, "OAuth2", ["stock-out:write"], configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(stockOutProductsUpdateRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * **Scope**:      stock_outs:write  **Parameters**:      uuid: The Stock Out event\'s UUID to update.
         * @summary Update StockOut for a given UUID
         * @param {string} uuid
         * @param {StockOutUpdateRequest} stockOutUpdateRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateStockOut: (uuid, stockOutUpdateRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            common_1.assertParamExists('updateStockOut', 'uuid', uuid);
            // verify required parameter 'stockOutUpdateRequest' is not null or undefined
            common_1.assertParamExists('updateStockOut', 'stockOutUpdateRequest', stockOutUpdateRequest);
            const localVarPath = `/stock-out/{uuid}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication OAuth2 required
            // oauth required
            yield common_1.setOAuthToObject(localVarHeaderParameter, "OAuth2", ["stock-out:write"], configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(stockOutUpdateRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * **Scope**:      stock-out:write  **Parameters**:      uuid: The Stock Out event\'s UUID to update.
         * @summary Updates the product list of a Stock Out event with the given UUID
         * @param {string} uuid
         * @param {StockOutProductsUpdateRequest} stockOutProductsUpdateRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateStockOutProducts: (uuid, stockOutProductsUpdateRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            common_1.assertParamExists('updateStockOutProducts', 'uuid', uuid);
            // verify required parameter 'stockOutProductsUpdateRequest' is not null or undefined
            common_1.assertParamExists('updateStockOutProducts', 'stockOutProductsUpdateRequest', stockOutProductsUpdateRequest);
            const localVarPath = `/stock-out/{uuid}/products`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication OAuth2 required
            // oauth required
            yield common_1.setOAuthToObject(localVarHeaderParameter, "OAuth2", ["stock-out:write"], configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(stockOutProductsUpdateRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * StockOutEventApi - functional programming interface
 * @export
 */
exports.StockOutEventApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.StockOutEventApiAxiosParamCreator(configuration);
    return {
        /**
         * **Scope**:      stock-out:write
         * @summary Create a new Stock Out event
         * @param {StockOutRequest} stockOutRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createStockOut(stockOutRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createStockOut(stockOutRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * **Scope**:      stock_outs:admin  **Parameters**:      uuid: The Stock Out event\'s UUID to delete
         * @summary Delete StockOut for a given UUID
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteStockOut(uuid, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteStockOut(uuid, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * **Scope**:      stock-out:read  **Parameters**:      stock_out_uuid: The Stock Out event\'s UUID to retrieve.
         * @summary Get Stock Out for a given UUID
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStockOut(uuid, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getStockOut(uuid, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * **Scope**:      stock-out:read  **Parameters**:      reason: A reason to only select events which have this reason specified.     location_uuid: An UUID to use to only select events emitted by a specific Kitchen.     order_by: A field to uses when ordering the collection.     desc: Should the ordering be reversed?     start_after: An event UUID to use to start the iterator page after.     per_page: The number of event per page (by default it\'s 20).     with_deleted: Should we retrieve soft-deleted events too?
         * @summary Retrieve all StockOut
         * @param {ReasonEnum} [reason]
         * @param {string} [locationUuid]
         * @param {ListOrderByParam} [orderBy]
         * @param {boolean} [desc]
         * @param {string} [startAfter]
         * @param {number} [perPage]
         * @param {boolean} [withDeleted]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listStockOut(reason, locationUuid, orderBy, desc, startAfter, perPage, withDeleted, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listStockOut(reason, locationUuid, orderBy, desc, startAfter, perPage, withDeleted, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * **Scope**:      stock-out:write  **Parameters**:      uuid: The Stock Out event\'s UUID to update.
         * @summary Updates the product list of a Stock Out event with the given UUID
         * @param {string} uuid
         * @param {StockOutProductsUpdateRequest} stockOutProductsUpdateRequest
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        oldUpdateStockOutProducts(uuid, stockOutProductsUpdateRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.oldUpdateStockOutProducts(uuid, stockOutProductsUpdateRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * **Scope**:      stock_outs:write  **Parameters**:      uuid: The Stock Out event\'s UUID to update.
         * @summary Update StockOut for a given UUID
         * @param {string} uuid
         * @param {StockOutUpdateRequest} stockOutUpdateRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateStockOut(uuid, stockOutUpdateRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateStockOut(uuid, stockOutUpdateRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * **Scope**:      stock-out:write  **Parameters**:      uuid: The Stock Out event\'s UUID to update.
         * @summary Updates the product list of a Stock Out event with the given UUID
         * @param {string} uuid
         * @param {StockOutProductsUpdateRequest} stockOutProductsUpdateRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateStockOutProducts(uuid, stockOutProductsUpdateRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateStockOutProducts(uuid, stockOutProductsUpdateRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
/**
 * StockOutEventApi - factory interface
 * @export
 */
exports.StockOutEventApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.StockOutEventApiFp(configuration);
    return {
        /**
         * **Scope**:      stock-out:write
         * @summary Create a new Stock Out event
         * @param {StockOutRequest} stockOutRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createStockOut(stockOutRequest, options) {
            return localVarFp.createStockOut(stockOutRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * **Scope**:      stock_outs:admin  **Parameters**:      uuid: The Stock Out event\'s UUID to delete
         * @summary Delete StockOut for a given UUID
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteStockOut(uuid, options) {
            return localVarFp.deleteStockOut(uuid, options).then((request) => request(axios, basePath));
        },
        /**
         * **Scope**:      stock-out:read  **Parameters**:      stock_out_uuid: The Stock Out event\'s UUID to retrieve.
         * @summary Get Stock Out for a given UUID
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStockOut(uuid, options) {
            return localVarFp.getStockOut(uuid, options).then((request) => request(axios, basePath));
        },
        /**
         * **Scope**:      stock-out:read  **Parameters**:      reason: A reason to only select events which have this reason specified.     location_uuid: An UUID to use to only select events emitted by a specific Kitchen.     order_by: A field to uses when ordering the collection.     desc: Should the ordering be reversed?     start_after: An event UUID to use to start the iterator page after.     per_page: The number of event per page (by default it\'s 20).     with_deleted: Should we retrieve soft-deleted events too?
         * @summary Retrieve all StockOut
         * @param {ReasonEnum} [reason]
         * @param {string} [locationUuid]
         * @param {ListOrderByParam} [orderBy]
         * @param {boolean} [desc]
         * @param {string} [startAfter]
         * @param {number} [perPage]
         * @param {boolean} [withDeleted]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listStockOut(reason, locationUuid, orderBy, desc, startAfter, perPage, withDeleted, options) {
            return localVarFp.listStockOut(reason, locationUuid, orderBy, desc, startAfter, perPage, withDeleted, options).then((request) => request(axios, basePath));
        },
        /**
         * **Scope**:      stock-out:write  **Parameters**:      uuid: The Stock Out event\'s UUID to update.
         * @summary Updates the product list of a Stock Out event with the given UUID
         * @param {string} uuid
         * @param {StockOutProductsUpdateRequest} stockOutProductsUpdateRequest
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        oldUpdateStockOutProducts(uuid, stockOutProductsUpdateRequest, options) {
            return localVarFp.oldUpdateStockOutProducts(uuid, stockOutProductsUpdateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * **Scope**:      stock_outs:write  **Parameters**:      uuid: The Stock Out event\'s UUID to update.
         * @summary Update StockOut for a given UUID
         * @param {string} uuid
         * @param {StockOutUpdateRequest} stockOutUpdateRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateStockOut(uuid, stockOutUpdateRequest, options) {
            return localVarFp.updateStockOut(uuid, stockOutUpdateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * **Scope**:      stock-out:write  **Parameters**:      uuid: The Stock Out event\'s UUID to update.
         * @summary Updates the product list of a Stock Out event with the given UUID
         * @param {string} uuid
         * @param {StockOutProductsUpdateRequest} stockOutProductsUpdateRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateStockOutProducts(uuid, stockOutProductsUpdateRequest, options) {
            return localVarFp.updateStockOutProducts(uuid, stockOutProductsUpdateRequest, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * StockOutEventApi - object-oriented interface
 * @export
 * @class StockOutEventApi
 * @extends {BaseAPI}
 */
class StockOutEventApi extends base_1.BaseAPI {
    /**
     * **Scope**:      stock-out:write
     * @summary Create a new Stock Out event
     * @param {StockOutRequest} stockOutRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StockOutEventApi
     */
    createStockOut(stockOutRequest, options) {
        return exports.StockOutEventApiFp(this.configuration).createStockOut(stockOutRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * **Scope**:      stock_outs:admin  **Parameters**:      uuid: The Stock Out event\'s UUID to delete
     * @summary Delete StockOut for a given UUID
     * @param {string} uuid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StockOutEventApi
     */
    deleteStockOut(uuid, options) {
        return exports.StockOutEventApiFp(this.configuration).deleteStockOut(uuid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * **Scope**:      stock-out:read  **Parameters**:      stock_out_uuid: The Stock Out event\'s UUID to retrieve.
     * @summary Get Stock Out for a given UUID
     * @param {string} uuid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StockOutEventApi
     */
    getStockOut(uuid, options) {
        return exports.StockOutEventApiFp(this.configuration).getStockOut(uuid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * **Scope**:      stock-out:read  **Parameters**:      reason: A reason to only select events which have this reason specified.     location_uuid: An UUID to use to only select events emitted by a specific Kitchen.     order_by: A field to uses when ordering the collection.     desc: Should the ordering be reversed?     start_after: An event UUID to use to start the iterator page after.     per_page: The number of event per page (by default it\'s 20).     with_deleted: Should we retrieve soft-deleted events too?
     * @summary Retrieve all StockOut
     * @param {ReasonEnum} [reason]
     * @param {string} [locationUuid]
     * @param {ListOrderByParam} [orderBy]
     * @param {boolean} [desc]
     * @param {string} [startAfter]
     * @param {number} [perPage]
     * @param {boolean} [withDeleted]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StockOutEventApi
     */
    listStockOut(reason, locationUuid, orderBy, desc, startAfter, perPage, withDeleted, options) {
        return exports.StockOutEventApiFp(this.configuration).listStockOut(reason, locationUuid, orderBy, desc, startAfter, perPage, withDeleted, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * **Scope**:      stock-out:write  **Parameters**:      uuid: The Stock Out event\'s UUID to update.
     * @summary Updates the product list of a Stock Out event with the given UUID
     * @param {string} uuid
     * @param {StockOutProductsUpdateRequest} stockOutProductsUpdateRequest
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof StockOutEventApi
     */
    oldUpdateStockOutProducts(uuid, stockOutProductsUpdateRequest, options) {
        return exports.StockOutEventApiFp(this.configuration).oldUpdateStockOutProducts(uuid, stockOutProductsUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * **Scope**:      stock_outs:write  **Parameters**:      uuid: The Stock Out event\'s UUID to update.
     * @summary Update StockOut for a given UUID
     * @param {string} uuid
     * @param {StockOutUpdateRequest} stockOutUpdateRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StockOutEventApi
     */
    updateStockOut(uuid, stockOutUpdateRequest, options) {
        return exports.StockOutEventApiFp(this.configuration).updateStockOut(uuid, stockOutUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * **Scope**:      stock-out:write  **Parameters**:      uuid: The Stock Out event\'s UUID to update.
     * @summary Updates the product list of a Stock Out event with the given UUID
     * @param {string} uuid
     * @param {StockOutProductsUpdateRequest} stockOutProductsUpdateRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StockOutEventApi
     */
    updateStockOutProducts(uuid, stockOutProductsUpdateRequest, options) {
        return exports.StockOutEventApiFp(this.configuration).updateStockOutProducts(uuid, stockOutProductsUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.StockOutEventApi = StockOutEventApi;
/**
 * StockTransferEventApi - axios parameter creator
 * @export
 */
exports.StockTransferEventApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * **Scope**:      transfer:write
         * @summary Create a new Stock Transfer event
         * @param {TransferRequest} transferRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTransfer: (transferRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'transferRequest' is not null or undefined
            common_1.assertParamExists('createTransfer', 'transferRequest', transferRequest);
            const localVarPath = `/transfer`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication OAuth2 required
            // oauth required
            yield common_1.setOAuthToObject(localVarHeaderParameter, "OAuth2", ["transfer:write"], configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(transferRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * **Scope**:      transfer:admin  **Parameters**:      uuid: The Stock Transfer event\'s UUID to delete.
         * @summary Delete a Stock Transfer event for a given UUID
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTransfer: (uuid, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            common_1.assertParamExists('deleteTransfer', 'uuid', uuid);
            const localVarPath = `/transfer/{uuid}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication OAuth2 required
            // oauth required
            yield common_1.setOAuthToObject(localVarHeaderParameter, "OAuth2", ["transfer:admin"], configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * **Scopes**:      transfer:read  **Parameters**:      uuid: The Stock Transfer event\'s UUID to retrieve.
         * @summary Get a Stock Transfer event for a given UUID
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTransfer: (uuid, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            common_1.assertParamExists('getTransfer', 'uuid', uuid);
            const localVarPath = `/transfer/{uuid}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication OAuth2 required
            // oauth required
            yield common_1.setOAuthToObject(localVarHeaderParameter, "OAuth2", ["transfer:read"], configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * **Scopes**:      stock-in:read  **Parameters**:      uuid: The Stock Transfer event\'s UUID.     expiration: A custom duration, in minutes, for the expiration delay of the signed URLs.
         * @summary Get the signed URLs to a Stock Transfer event\'s delivery notes for a given UUID.
         * @param {string} uuid
         * @param {number} [expiration]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTransferDeliveryNotes: (uuid, expiration, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            common_1.assertParamExists('getTransferDeliveryNotes', 'uuid', uuid);
            const localVarPath = `/transfer/{uuid}/delivery-notes`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication OAuth2 required
            // oauth required
            yield common_1.setOAuthToObject(localVarHeaderParameter, "OAuth2", ["transfer:read"], configuration);
            if (expiration !== undefined) {
                localVarQueryParameter['expiration'] = expiration;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * **Scope**:      transfer:read  **Parameters**:      reason: A reason to only select events which have this reason specified.     delivery_date: A date to only select events which are delivered on this day.     delivery_status: A status to only select events which are in this status.     destination_uuid: An UUID to use to only select events which are directed to this specific Kitchen.     location_uuid: An UUID to use to only select events emitted by a specific Kitchen.     order_by: A field to uses when ordering the collection.     desc: Should the ordering be reversed?     start_after: An event UUID to use to start the iterator page after.     per_page: The number of event per page (by default it\'s 20).     with_deleted: Should we retrieve soft-deleted events too?
         * @summary Retrieve an iterator on Transfer events
         * @param {ReasonEnum} [reason]
         * @param {string} [deliveryDate]
         * @param {StatusEnum} [deliveryStatus]
         * @param {string} [kitchenUuid]
         * @param {string} [destinationUuid]
         * @param {string} [locationUuid]
         * @param {TransferListOrderByParam} [orderBy]
         * @param {boolean} [desc]
         * @param {string} [startAfter]
         * @param {number} [perPage]
         * @param {boolean} [withDeleted]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTransfer: (reason, deliveryDate, deliveryStatus, kitchenUuid, destinationUuid, locationUuid, orderBy, desc, startAfter, perPage, withDeleted, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/transfer`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication OAuth2 required
            // oauth required
            yield common_1.setOAuthToObject(localVarHeaderParameter, "OAuth2", ["transfer:read"], configuration);
            if (reason !== undefined) {
                localVarQueryParameter['reason'] = reason;
            }
            if (deliveryDate !== undefined) {
                localVarQueryParameter['delivery_date'] = (deliveryDate instanceof Date) ?
                    deliveryDate.toISOString().substr(0, 10) :
                    deliveryDate;
            }
            if (deliveryStatus !== undefined) {
                localVarQueryParameter['delivery_status'] = deliveryStatus;
            }
            if (kitchenUuid !== undefined) {
                localVarQueryParameter['kitchen_uuid'] = kitchenUuid;
            }
            if (destinationUuid !== undefined) {
                localVarQueryParameter['destination_uuid'] = destinationUuid;
            }
            if (locationUuid !== undefined) {
                localVarQueryParameter['location_uuid'] = locationUuid;
            }
            if (orderBy !== undefined) {
                localVarQueryParameter['order_by'] = orderBy;
            }
            if (desc !== undefined) {
                localVarQueryParameter['desc'] = desc;
            }
            if (startAfter !== undefined) {
                localVarQueryParameter['start_after'] = startAfter;
            }
            if (perPage !== undefined) {
                localVarQueryParameter['per_page'] = perPage;
            }
            if (withDeleted !== undefined) {
                localVarQueryParameter['with_deleted'] = withDeleted;
            }
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * **Scope**:      transfer:write  **Parameters**:      uuid: The Stock Transfer event\'s UUID to update.
         * @summary Updates the product list of a Stock Transfer event with the given UUID
         * @param {string} uuid
         * @param {TransferProductsUpdateRequest} transferProductsUpdateRequest
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        oldUpdateTransferProducts: (uuid, transferProductsUpdateRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            common_1.assertParamExists('oldUpdateTransferProducts', 'uuid', uuid);
            // verify required parameter 'transferProductsUpdateRequest' is not null or undefined
            common_1.assertParamExists('oldUpdateTransferProducts', 'transferProductsUpdateRequest', transferProductsUpdateRequest);
            const localVarPath = `/transfer/{uuid}/products`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication OAuth2 required
            // oauth required
            yield common_1.setOAuthToObject(localVarHeaderParameter, "OAuth2", ["transfer:write"], configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(transferProductsUpdateRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * **Scope**:      transfer:write  **Parameters**:      uuid: The Stock Transfer event\'s UUID to update.
         * @summary Pass a Stock Transfer event from AWAITING_DELIVERY to DELIVERED
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        passTransferToDelivered: (uuid, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            common_1.assertParamExists('passTransferToDelivered', 'uuid', uuid);
            const localVarPath = `/transfer/{uuid}/deliver`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication OAuth2 required
            // oauth required
            yield common_1.setOAuthToObject(localVarHeaderParameter, "OAuth2", ["transfer:write"], configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * **Scope**:      transfer:write  **Parameters**:      uuid: The Transfer event\'s UUID to update.
         * @summary Update a Stock Transfer for a given UUID
         * @param {string} uuid
         * @param {TransferUpdateRequest} transferUpdateRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTransfer: (uuid, transferUpdateRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            common_1.assertParamExists('updateTransfer', 'uuid', uuid);
            // verify required parameter 'transferUpdateRequest' is not null or undefined
            common_1.assertParamExists('updateTransfer', 'transferUpdateRequest', transferUpdateRequest);
            const localVarPath = `/transfer/{uuid}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication OAuth2 required
            // oauth required
            yield common_1.setOAuthToObject(localVarHeaderParameter, "OAuth2", ["transfer:write"], configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(transferUpdateRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * **Scope**:      transfer:write  **Parameters**:      uuid: The Stock Transfer event\'s UUID to update.     product_uuid: The attached Product\'s UUID to update.
         * @summary Updates a product of a Stock Transfer event with the given UUID
         * @param {string} uuid
         * @param {string} productUuid
         * @param {TransferProductUpdateRequest} transferProductUpdateRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTransferProduct: (uuid, productUuid, transferProductUpdateRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            common_1.assertParamExists('updateTransferProduct', 'uuid', uuid);
            // verify required parameter 'productUuid' is not null or undefined
            common_1.assertParamExists('updateTransferProduct', 'productUuid', productUuid);
            // verify required parameter 'transferProductUpdateRequest' is not null or undefined
            common_1.assertParamExists('updateTransferProduct', 'transferProductUpdateRequest', transferProductUpdateRequest);
            const localVarPath = `/transfer/{uuid}/products/{product_uuid}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)))
                .replace(`{${"product_uuid"}}`, encodeURIComponent(String(productUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication OAuth2 required
            // oauth required
            yield common_1.setOAuthToObject(localVarHeaderParameter, "OAuth2", ["transfer:write"], configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(transferProductUpdateRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * **Scope**:      transfer:write  **Parameters**:      uuid: The Stock Transfer event\'s UUID to update.
         * @summary Updates the product list of a Stock Transfer event with the given UUID
         * @param {string} uuid
         * @param {TransferProductsUpdateRequest} transferProductsUpdateRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTransferProducts: (uuid, transferProductsUpdateRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            common_1.assertParamExists('updateTransferProducts', 'uuid', uuid);
            // verify required parameter 'transferProductsUpdateRequest' is not null or undefined
            common_1.assertParamExists('updateTransferProducts', 'transferProductsUpdateRequest', transferProductsUpdateRequest);
            const localVarPath = `/transfer/{uuid}/products`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication OAuth2 required
            // oauth required
            yield common_1.setOAuthToObject(localVarHeaderParameter, "OAuth2", ["transfer:write"], configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(transferProductsUpdateRequest, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * **Scope**:      transfer:write  **Parameters**:      uuid: The Stock Transfer event\'s UUID to use to attach the delivery note.
         * @summary Upload a delivery note to attach to a Stock Transfer event for a given UUID
         * @param {string} uuid
         * @param {any} note
         * @param {string} deliverLabel
         * @param {string} kitchenId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadTransferNote: (uuid, note, deliverLabel, kitchenId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uuid' is not null or undefined
            common_1.assertParamExists('uploadTransferNote', 'uuid', uuid);
            // verify required parameter 'note' is not null or undefined
            common_1.assertParamExists('uploadTransferNote', 'note', note);
            // verify required parameter 'deliverLabel' is not null or undefined
            common_1.assertParamExists('uploadTransferNote', 'deliverLabel', deliverLabel);
            // verify required parameter 'kitchenId' is not null or undefined
            common_1.assertParamExists('uploadTransferNote', 'kitchenId', kitchenId);
            const localVarPath = `/transfer/{uuid}/upload-note`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();
            // authentication OAuth2 required
            // oauth required
            yield common_1.setOAuthToObject(localVarHeaderParameter, "OAuth2", ["transfer:write"], configuration);
            if (note !== undefined) {
                localVarFormParams.append('note', note);
            }
            if (deliverLabel !== undefined) {
                localVarFormParams.append('deliver_label', deliverLabel);
            }
            if (kitchenId !== undefined) {
                localVarFormParams.append('kitchen_id', kitchenId);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = localVarFormParams;
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * StockTransferEventApi - functional programming interface
 * @export
 */
exports.StockTransferEventApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.StockTransferEventApiAxiosParamCreator(configuration);
    return {
        /**
         * **Scope**:      transfer:write
         * @summary Create a new Stock Transfer event
         * @param {TransferRequest} transferRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTransfer(transferRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createTransfer(transferRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * **Scope**:      transfer:admin  **Parameters**:      uuid: The Stock Transfer event\'s UUID to delete.
         * @summary Delete a Stock Transfer event for a given UUID
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTransfer(uuid, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteTransfer(uuid, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * **Scopes**:      transfer:read  **Parameters**:      uuid: The Stock Transfer event\'s UUID to retrieve.
         * @summary Get a Stock Transfer event for a given UUID
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTransfer(uuid, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getTransfer(uuid, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * **Scopes**:      stock-in:read  **Parameters**:      uuid: The Stock Transfer event\'s UUID.     expiration: A custom duration, in minutes, for the expiration delay of the signed URLs.
         * @summary Get the signed URLs to a Stock Transfer event\'s delivery notes for a given UUID.
         * @param {string} uuid
         * @param {number} [expiration]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTransferDeliveryNotes(uuid, expiration, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getTransferDeliveryNotes(uuid, expiration, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * **Scope**:      transfer:read  **Parameters**:      reason: A reason to only select events which have this reason specified.     delivery_date: A date to only select events which are delivered on this day.     delivery_status: A status to only select events which are in this status.     destination_uuid: An UUID to use to only select events which are directed to this specific Kitchen.     location_uuid: An UUID to use to only select events emitted by a specific Kitchen.     order_by: A field to uses when ordering the collection.     desc: Should the ordering be reversed?     start_after: An event UUID to use to start the iterator page after.     per_page: The number of event per page (by default it\'s 20).     with_deleted: Should we retrieve soft-deleted events too?
         * @summary Retrieve an iterator on Transfer events
         * @param {ReasonEnum} [reason]
         * @param {string} [deliveryDate]
         * @param {StatusEnum} [deliveryStatus]
         * @param {string} [kitchenUuid]
         * @param {string} [destinationUuid]
         * @param {string} [locationUuid]
         * @param {TransferListOrderByParam} [orderBy]
         * @param {boolean} [desc]
         * @param {string} [startAfter]
         * @param {number} [perPage]
         * @param {boolean} [withDeleted]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTransfer(reason, deliveryDate, deliveryStatus, kitchenUuid, destinationUuid, locationUuid, orderBy, desc, startAfter, perPage, withDeleted, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listTransfer(reason, deliveryDate, deliveryStatus, kitchenUuid, destinationUuid, locationUuid, orderBy, desc, startAfter, perPage, withDeleted, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * **Scope**:      transfer:write  **Parameters**:      uuid: The Stock Transfer event\'s UUID to update.
         * @summary Updates the product list of a Stock Transfer event with the given UUID
         * @param {string} uuid
         * @param {TransferProductsUpdateRequest} transferProductsUpdateRequest
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        oldUpdateTransferProducts(uuid, transferProductsUpdateRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.oldUpdateTransferProducts(uuid, transferProductsUpdateRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * **Scope**:      transfer:write  **Parameters**:      uuid: The Stock Transfer event\'s UUID to update.
         * @summary Pass a Stock Transfer event from AWAITING_DELIVERY to DELIVERED
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        passTransferToDelivered(uuid, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.passTransferToDelivered(uuid, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * **Scope**:      transfer:write  **Parameters**:      uuid: The Transfer event\'s UUID to update.
         * @summary Update a Stock Transfer for a given UUID
         * @param {string} uuid
         * @param {TransferUpdateRequest} transferUpdateRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTransfer(uuid, transferUpdateRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateTransfer(uuid, transferUpdateRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * **Scope**:      transfer:write  **Parameters**:      uuid: The Stock Transfer event\'s UUID to update.     product_uuid: The attached Product\'s UUID to update.
         * @summary Updates a product of a Stock Transfer event with the given UUID
         * @param {string} uuid
         * @param {string} productUuid
         * @param {TransferProductUpdateRequest} transferProductUpdateRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTransferProduct(uuid, productUuid, transferProductUpdateRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateTransferProduct(uuid, productUuid, transferProductUpdateRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * **Scope**:      transfer:write  **Parameters**:      uuid: The Stock Transfer event\'s UUID to update.
         * @summary Updates the product list of a Stock Transfer event with the given UUID
         * @param {string} uuid
         * @param {TransferProductsUpdateRequest} transferProductsUpdateRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTransferProducts(uuid, transferProductsUpdateRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateTransferProducts(uuid, transferProductsUpdateRequest, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * **Scope**:      transfer:write  **Parameters**:      uuid: The Stock Transfer event\'s UUID to use to attach the delivery note.
         * @summary Upload a delivery note to attach to a Stock Transfer event for a given UUID
         * @param {string} uuid
         * @param {any} note
         * @param {string} deliverLabel
         * @param {string} kitchenId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadTransferNote(uuid, note, deliverLabel, kitchenId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.uploadTransferNote(uuid, note, deliverLabel, kitchenId, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
/**
 * StockTransferEventApi - factory interface
 * @export
 */
exports.StockTransferEventApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.StockTransferEventApiFp(configuration);
    return {
        /**
         * **Scope**:      transfer:write
         * @summary Create a new Stock Transfer event
         * @param {TransferRequest} transferRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTransfer(transferRequest, options) {
            return localVarFp.createTransfer(transferRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * **Scope**:      transfer:admin  **Parameters**:      uuid: The Stock Transfer event\'s UUID to delete.
         * @summary Delete a Stock Transfer event for a given UUID
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTransfer(uuid, options) {
            return localVarFp.deleteTransfer(uuid, options).then((request) => request(axios, basePath));
        },
        /**
         * **Scopes**:      transfer:read  **Parameters**:      uuid: The Stock Transfer event\'s UUID to retrieve.
         * @summary Get a Stock Transfer event for a given UUID
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTransfer(uuid, options) {
            return localVarFp.getTransfer(uuid, options).then((request) => request(axios, basePath));
        },
        /**
         * **Scopes**:      stock-in:read  **Parameters**:      uuid: The Stock Transfer event\'s UUID.     expiration: A custom duration, in minutes, for the expiration delay of the signed URLs.
         * @summary Get the signed URLs to a Stock Transfer event\'s delivery notes for a given UUID.
         * @param {string} uuid
         * @param {number} [expiration]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTransferDeliveryNotes(uuid, expiration, options) {
            return localVarFp.getTransferDeliveryNotes(uuid, expiration, options).then((request) => request(axios, basePath));
        },
        /**
         * **Scope**:      transfer:read  **Parameters**:      reason: A reason to only select events which have this reason specified.     delivery_date: A date to only select events which are delivered on this day.     delivery_status: A status to only select events which are in this status.     destination_uuid: An UUID to use to only select events which are directed to this specific Kitchen.     location_uuid: An UUID to use to only select events emitted by a specific Kitchen.     order_by: A field to uses when ordering the collection.     desc: Should the ordering be reversed?     start_after: An event UUID to use to start the iterator page after.     per_page: The number of event per page (by default it\'s 20).     with_deleted: Should we retrieve soft-deleted events too?
         * @summary Retrieve an iterator on Transfer events
         * @param {ReasonEnum} [reason]
         * @param {string} [deliveryDate]
         * @param {StatusEnum} [deliveryStatus]
         * @param {string} [kitchenUuid]
         * @param {string} [destinationUuid]
         * @param {string} [locationUuid]
         * @param {TransferListOrderByParam} [orderBy]
         * @param {boolean} [desc]
         * @param {string} [startAfter]
         * @param {number} [perPage]
         * @param {boolean} [withDeleted]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTransfer(reason, deliveryDate, deliveryStatus, kitchenUuid, destinationUuid, locationUuid, orderBy, desc, startAfter, perPage, withDeleted, options) {
            return localVarFp.listTransfer(reason, deliveryDate, deliveryStatus, kitchenUuid, destinationUuid, locationUuid, orderBy, desc, startAfter, perPage, withDeleted, options).then((request) => request(axios, basePath));
        },
        /**
         * **Scope**:      transfer:write  **Parameters**:      uuid: The Stock Transfer event\'s UUID to update.
         * @summary Updates the product list of a Stock Transfer event with the given UUID
         * @param {string} uuid
         * @param {TransferProductsUpdateRequest} transferProductsUpdateRequest
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        oldUpdateTransferProducts(uuid, transferProductsUpdateRequest, options) {
            return localVarFp.oldUpdateTransferProducts(uuid, transferProductsUpdateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * **Scope**:      transfer:write  **Parameters**:      uuid: The Stock Transfer event\'s UUID to update.
         * @summary Pass a Stock Transfer event from AWAITING_DELIVERY to DELIVERED
         * @param {string} uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        passTransferToDelivered(uuid, options) {
            return localVarFp.passTransferToDelivered(uuid, options).then((request) => request(axios, basePath));
        },
        /**
         * **Scope**:      transfer:write  **Parameters**:      uuid: The Transfer event\'s UUID to update.
         * @summary Update a Stock Transfer for a given UUID
         * @param {string} uuid
         * @param {TransferUpdateRequest} transferUpdateRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTransfer(uuid, transferUpdateRequest, options) {
            return localVarFp.updateTransfer(uuid, transferUpdateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * **Scope**:      transfer:write  **Parameters**:      uuid: The Stock Transfer event\'s UUID to update.     product_uuid: The attached Product\'s UUID to update.
         * @summary Updates a product of a Stock Transfer event with the given UUID
         * @param {string} uuid
         * @param {string} productUuid
         * @param {TransferProductUpdateRequest} transferProductUpdateRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTransferProduct(uuid, productUuid, transferProductUpdateRequest, options) {
            return localVarFp.updateTransferProduct(uuid, productUuid, transferProductUpdateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * **Scope**:      transfer:write  **Parameters**:      uuid: The Stock Transfer event\'s UUID to update.
         * @summary Updates the product list of a Stock Transfer event with the given UUID
         * @param {string} uuid
         * @param {TransferProductsUpdateRequest} transferProductsUpdateRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTransferProducts(uuid, transferProductsUpdateRequest, options) {
            return localVarFp.updateTransferProducts(uuid, transferProductsUpdateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * **Scope**:      transfer:write  **Parameters**:      uuid: The Stock Transfer event\'s UUID to use to attach the delivery note.
         * @summary Upload a delivery note to attach to a Stock Transfer event for a given UUID
         * @param {string} uuid
         * @param {any} note
         * @param {string} deliverLabel
         * @param {string} kitchenId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadTransferNote(uuid, note, deliverLabel, kitchenId, options) {
            return localVarFp.uploadTransferNote(uuid, note, deliverLabel, kitchenId, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * StockTransferEventApi - object-oriented interface
 * @export
 * @class StockTransferEventApi
 * @extends {BaseAPI}
 */
class StockTransferEventApi extends base_1.BaseAPI {
    /**
     * **Scope**:      transfer:write
     * @summary Create a new Stock Transfer event
     * @param {TransferRequest} transferRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StockTransferEventApi
     */
    createTransfer(transferRequest, options) {
        return exports.StockTransferEventApiFp(this.configuration).createTransfer(transferRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * **Scope**:      transfer:admin  **Parameters**:      uuid: The Stock Transfer event\'s UUID to delete.
     * @summary Delete a Stock Transfer event for a given UUID
     * @param {string} uuid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StockTransferEventApi
     */
    deleteTransfer(uuid, options) {
        return exports.StockTransferEventApiFp(this.configuration).deleteTransfer(uuid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * **Scopes**:      transfer:read  **Parameters**:      uuid: The Stock Transfer event\'s UUID to retrieve.
     * @summary Get a Stock Transfer event for a given UUID
     * @param {string} uuid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StockTransferEventApi
     */
    getTransfer(uuid, options) {
        return exports.StockTransferEventApiFp(this.configuration).getTransfer(uuid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * **Scopes**:      stock-in:read  **Parameters**:      uuid: The Stock Transfer event\'s UUID.     expiration: A custom duration, in minutes, for the expiration delay of the signed URLs.
     * @summary Get the signed URLs to a Stock Transfer event\'s delivery notes for a given UUID.
     * @param {string} uuid
     * @param {number} [expiration]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StockTransferEventApi
     */
    getTransferDeliveryNotes(uuid, expiration, options) {
        return exports.StockTransferEventApiFp(this.configuration).getTransferDeliveryNotes(uuid, expiration, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * **Scope**:      transfer:read  **Parameters**:      reason: A reason to only select events which have this reason specified.     delivery_date: A date to only select events which are delivered on this day.     delivery_status: A status to only select events which are in this status.     destination_uuid: An UUID to use to only select events which are directed to this specific Kitchen.     location_uuid: An UUID to use to only select events emitted by a specific Kitchen.     order_by: A field to uses when ordering the collection.     desc: Should the ordering be reversed?     start_after: An event UUID to use to start the iterator page after.     per_page: The number of event per page (by default it\'s 20).     with_deleted: Should we retrieve soft-deleted events too?
     * @summary Retrieve an iterator on Transfer events
     * @param {ReasonEnum} [reason]
     * @param {string} [deliveryDate]
     * @param {StatusEnum} [deliveryStatus]
     * @param {string} [kitchenUuid]
     * @param {string} [destinationUuid]
     * @param {string} [locationUuid]
     * @param {TransferListOrderByParam} [orderBy]
     * @param {boolean} [desc]
     * @param {string} [startAfter]
     * @param {number} [perPage]
     * @param {boolean} [withDeleted]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StockTransferEventApi
     */
    listTransfer(reason, deliveryDate, deliveryStatus, kitchenUuid, destinationUuid, locationUuid, orderBy, desc, startAfter, perPage, withDeleted, options) {
        return exports.StockTransferEventApiFp(this.configuration).listTransfer(reason, deliveryDate, deliveryStatus, kitchenUuid, destinationUuid, locationUuid, orderBy, desc, startAfter, perPage, withDeleted, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * **Scope**:      transfer:write  **Parameters**:      uuid: The Stock Transfer event\'s UUID to update.
     * @summary Updates the product list of a Stock Transfer event with the given UUID
     * @param {string} uuid
     * @param {TransferProductsUpdateRequest} transferProductsUpdateRequest
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof StockTransferEventApi
     */
    oldUpdateTransferProducts(uuid, transferProductsUpdateRequest, options) {
        return exports.StockTransferEventApiFp(this.configuration).oldUpdateTransferProducts(uuid, transferProductsUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * **Scope**:      transfer:write  **Parameters**:      uuid: The Stock Transfer event\'s UUID to update.
     * @summary Pass a Stock Transfer event from AWAITING_DELIVERY to DELIVERED
     * @param {string} uuid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StockTransferEventApi
     */
    passTransferToDelivered(uuid, options) {
        return exports.StockTransferEventApiFp(this.configuration).passTransferToDelivered(uuid, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * **Scope**:      transfer:write  **Parameters**:      uuid: The Transfer event\'s UUID to update.
     * @summary Update a Stock Transfer for a given UUID
     * @param {string} uuid
     * @param {TransferUpdateRequest} transferUpdateRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StockTransferEventApi
     */
    updateTransfer(uuid, transferUpdateRequest, options) {
        return exports.StockTransferEventApiFp(this.configuration).updateTransfer(uuid, transferUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * **Scope**:      transfer:write  **Parameters**:      uuid: The Stock Transfer event\'s UUID to update.     product_uuid: The attached Product\'s UUID to update.
     * @summary Updates a product of a Stock Transfer event with the given UUID
     * @param {string} uuid
     * @param {string} productUuid
     * @param {TransferProductUpdateRequest} transferProductUpdateRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StockTransferEventApi
     */
    updateTransferProduct(uuid, productUuid, transferProductUpdateRequest, options) {
        return exports.StockTransferEventApiFp(this.configuration).updateTransferProduct(uuid, productUuid, transferProductUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * **Scope**:      transfer:write  **Parameters**:      uuid: The Stock Transfer event\'s UUID to update.
     * @summary Updates the product list of a Stock Transfer event with the given UUID
     * @param {string} uuid
     * @param {TransferProductsUpdateRequest} transferProductsUpdateRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StockTransferEventApi
     */
    updateTransferProducts(uuid, transferProductsUpdateRequest, options) {
        return exports.StockTransferEventApiFp(this.configuration).updateTransferProducts(uuid, transferProductsUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * **Scope**:      transfer:write  **Parameters**:      uuid: The Stock Transfer event\'s UUID to use to attach the delivery note.
     * @summary Upload a delivery note to attach to a Stock Transfer event for a given UUID
     * @param {string} uuid
     * @param {any} note
     * @param {string} deliverLabel
     * @param {string} kitchenId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StockTransferEventApi
     */
    uploadTransferNote(uuid, note, deliverLabel, kitchenId, options) {
        return exports.StockTransferEventApiFp(this.configuration).uploadTransferNote(uuid, note, deliverLabel, kitchenId, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.StockTransferEventApi = StockTransferEventApi;
